// Module
var code = "<div id=\"notification-layout-container\" ng-if=\"!indicators.loadingNotificationSettings && !indicators.error\"><user-notification-settings-top-nav-bar></user-notification-settings-top-nav-bar><gh-personal-notification></gh-personal-notification></div>";
// Exports
module.exports = code;